import { render, staticRenderFns } from "./indexDetail.vue?vue&type=template&id=5e312e1c&"
import script from "./indexDetail.vue?vue&type=script&lang=js&"
export * from "./indexDetail.vue?vue&type=script&lang=js&"
import style0 from "./indexDetail.vue?vue&type=style&index=0&id=5e312e1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports